export const calculateYearsOfExperience = (): number => {
  const startDate = new Date("2020-06-01"); // June 1, 2020
  const currentDate = new Date();

  const timeDifference = currentDate.getTime() - startDate.getTime();
  const yearsDifference = timeDifference / (1000 * 3600 * 24 * 365.25);

  return Math.floor(yearsDifference);
};

export const formatObjective = (objective: string): string => {
  const yearsOfExperience = calculateYearsOfExperience();
  return objective.replace(
    "{{yearsOfExperience}}",
    yearsOfExperience.toString()
  );
};
